import React, { Component } from "react";
//stripe-resource
import { Elements } from "@stripe/react-stripe-js";
import CardForm from "../CardForm/CardForm";
import { withRouter } from "react-router-dom";
import { connect } from "react-redux";

class AddCardContainer extends Component {
  constructor(props) {
    super(props);
    this.state = {};
  }

  componentDidMount = () => {};

  componentDidUpdate = () => {};

  render() {
    return (
      <>
        <Elements stripe={this.props.stripe}>
            <CardForm></CardForm>
        </Elements>
      </>
    );
  }
}

function mapStateToProps(state) {
  return {};
}

export default withRouter(
  connect(mapStateToProps)(AddCardContainer)
);
